import React from 'react';

import {cx} from '../../util';

const COLORS = {
  gray: 'bg-gray-50 border-gray-200 text-gray-600',
  sky: 'bg-sky-50 border-sky-200/70 text-sky-700',
  indigo: 'bg-indigo-50 border-indigo-200/70 text-indigo-700',
  violet: 'bg-violet-50 border-violet-200/70 text-violet-700',
  amber: 'bg-amber-50 border-amber-200/70 text-amber-700',
  emerald: 'bg-emerald-50 border-emerald-200/70 text-emerald-700',
  rose: 'bg-rose-50 border-rose-200/70 text-rose-700',
};

/** Small tinted pill, usable directly in lesson markdown and inside tables. */
const Pill = ({color = 'gray', className, children}) => (
  <span
    className={cx(
      'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold tracking-tight whitespace-nowrap',
      COLORS[color] || COLORS.gray,
      className,
    )}
  >
    {children}
  </span>
);

export default Pill;
